module.exports = __webpack_public_path__ + "static/ByteCamp-Info-light-e6585a95c6f5083d9c4b21e7f2f875a2.svg";